import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { clipping_model_editable, clipping_on } from '@features/clipping';
import mirror_svg from '../../../assets/img/SVG_icons/Top/advanced_operation/mirror.svg';
import { img } from '@phi/components';
import { clear_mirror_plane, complete_setting_mirror_plane, set_mirror_plane } from '@frontend/scene';
import MirrorTooltip from './MirrorTooltip';
import { ISubscriptions } from '@phi/subscriptions/frontend';

export const MirrorIcon = mirror_svg;

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        subscriptions: { required: true, type: Object as PropType<ISubscriptions> },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Mirror';
        },

        disabled() {
            return !this.state.loaded
                || this.state.editing_reference_partstudio
                || this.state.editing_reference_sketches
                || this.state.editing_reference_stl
                || this.state.rigid_move_manipulator
                || (
                    clipping_on.value
                    && !clipping_model_editable.value
                );
        },

        active() {
            return this.state.setting_mirror_plane
                || this.state.mirror_plane_selected;
        },
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.state.setting_mirror_plane)
                complete_setting_mirror_plane();
            else if (this.state.mirror_plane_selected)
                clear_mirror_plane();
            else
                set_mirror_plane();
        },
    },

    render() {
        return h(BarButton, {
            wrapperId: 'mirror-wrapper',
            id: 'mirror-button',
            onClick: this.onClick,
            active: this.active,
            disabled: this.disabled,
            selected: this.state.tut_stage === 9,
            tippy: 'left',
            help: 'mirror',
        }, {
            label: () => 'Mirror',
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(mirror_svg, this.alt),
            tooltip: MirrorTooltip,
        });
    },
});
